export const sfmViewerLayering = {
  webGlCanvasContainer: 0,
  css3dCanvasContainer: 1,
  gcpLabels: 2,
  tooltip: 3,
  menu: 4,
  placeMarkersContainer: 5,
  placeMarkersContainerMenu: 6,
};
